export default __webpack_public_path__ + "static/media/poles.f513b8d7.PNG";